import debug from "debug";
export const log = debug("auvious:media-pipe");
export function mergeConstraints(constraints) {
    const merged = Object.assign({}, constraints[0]);
    for (let i = 1; i < constraints.length; i++) {
        const b = constraints[i] || {};
        if (merged.audio && b.audio) {
            merged.audio =
                merged.audio === b.audio
                    ? merged.audio
                    : Object.assign(Object.assign({}, (merged.audio === true ? {} : merged.audio)), (b.audio === true ? {} : b.audio));
        }
        if (merged.video && b.video) {
            merged.video =
                merged.video === b.video
                    ? merged.video
                    : Object.assign(Object.assign({}, (merged.video === true ? {} : merged.video)), (b.video === true ? {} : b.video));
        }
    }
    log("merged constraints final", merged);
    return merged;
}
export function stopStream(stream, audio, video) {
    let stoppedAudio = false;
    let stoppedVideo = false;
    if (audio) {
        stream === null || stream === void 0 ? void 0 : stream.getAudioTracks().forEach((track) => {
            stoppedAudio = true;
            track.stop();
        });
    }
    if (video) {
        stream === null || stream === void 0 ? void 0 : stream.getVideoTracks().forEach((track) => {
            stoppedVideo = true;
            track.stop();
        });
    }
    return [stoppedAudio, stoppedVideo];
}
